<template>
  <el-pagination
    :disabled="disabled"
    :current-page.sync="num"
    @size-change="sizeChange"
    :total="page.total"
    :page-sizes="[10,20,50,100]"
    :page-size="page.pageSize"
    background
    layout="total, sizes, prev, pager, next, jumper"
    style="background:#fff"
  ></el-pagination>
</template>
<script>
export default {
  props: {
    page: { type: Object, required: true, default: { pageNum: 1, pageSize: 10, total: 0, changed: false } }
  },
  computed: {
    disabled() {//总数为0时分页控件不可用
      return this.page.total === 0
    },
    // pageSizes() {
    //     let p = new Array()
    //     p.push(this.page.pageSize)
    //     p.push(this.page.pageSize * 2)
    //     p.push(this.page.pageSize * 3)
    //     p.push(this.page.pageSize * 5)
    //     return p
    // }
  },
  watch: {
    num(val) {//监视当前页的变化
      this.pageChangeEvent()
    },
    'page.pageNum'(val) {//当前页=传入的页数
      this.num = val
    }
  },
  methods: {
    sizeChange(val) {//分页大小改变事件
      this.size = val
      this.pageChangeEvent()
    },
    pageChangeEvent() {
      //分页大小变大时，如果当前页大于改变后总页数，当前页会变为改变后最后一页，
      //会触发分页大小改变事件（先）和当前页改变事件（后），设置定时器限制只上抛一次事件
      clearTimeout(this.t)
      this.t = setTimeout(() => {
        this.$emit('update:page', {
          pageNum: this.num,
          pageSize: this.size || this.page.pageSize,
          changed: true,
          total: this.page.total
        })
        this.$emit('pageChange', {
          pageNum: this.num,
          pageSize: this.size || this.page.pageSize,
          changed: true,
          total: this.page.total
        })
      }, 100)
    },
  },
  data() {
    return {
      t: null,//定时器
      size: null,
      num: 1//当前页
    }
  }
}

</script>
<style lang="scss">
.el-pagination {
  .el-pagination__sizes {
    .el-select {
      .el-input__inner {
        height: 28px !important;
      }
    }
  }
}
</style>


